import { useEffect, useState } from "react";
import { masterjobStore } from "./masterjobStore";
import { useSnapshot } from "valtio";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export function LinkedBookings() {
    useSnapshot(masterjobStore)
    const [selectedIds, setSelectedIds] = useState([]);
    const linkedBookingsColumn = [
        { label: "", key: "checkbox" },
        { label: "Booking Id",key:"_id"},
        { label: "Shipment Number", key: "shippingBillNo" },
        { label: "HBL Number", key: "erpBookingId" },
        { label: "Customer", key: "entityName" },
        { label: "Origin", key: "origin" },
        { label: "Destination", key: "destination" },
        { label: "Trade", key: "trade" },
        { label: "Containers", key: "containers" },
        { label: "Status", key: "status" },
    ];

    const [bookingData, setBookingData] = useState([])  

    useEffect(()=>{
        // Api.getmasterjobbyid(masterjobStore.current._id,(e)=>{
            const filteredBookingData = masterjobStore?.bookingData?.filter(
              booking => !masterjobStore?.current?.linkedBookings?.includes(booking._id)
            );
            setBookingData(filteredBookingData);
        // })
    },[])

    return (
        <div style={{ borderRadius: "6px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", position: "fixed", inset: 0, top: "50px", zIndex: 1000, display: "flex", flexDirection: "column", overflowY: "auto" }} className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px] mt-[5px]">
            <div className="flex flex-row justify-between items-center">
                <p className="text-black font-bold">
                    Linked Bookings ({bookingData.length})
                </p>
                <button
                    className="button is-danger is-small"
                    onClick={() => {
                        masterjobStore.linkedBookings = false;
                    }}
                    style={{
                        borderRadius: "50%",
                        width: "32px",
                        height: "32px",
                        padding: 0,
                        float: "right",
                    }}
                >
                    <span className="icon">
                        <i className="fas fa-xmark"></i>
                    </span>
                </button>
            </div>
            <Breadcrumbs separator=">"  aria-label="breadcrumb">
                <Link
                    underline="hover"
                    color="inherit"
                    onClick={() => masterjobStore.linkedBookings = false }
                    sx={{ cursor: "pointer" }}
                >
                    Edit Master Job
                </Link>

                <Typography color="#2D3E91" fontWeight={600}>
                    Link Bookings
                </Typography>
            </Breadcrumbs>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                {masterjobStore?.bookingListId?.length > 0 ? <button
                    onClick={() => {
                        masterjobStore.current.linkedBookings = [...(masterjobStore.current.linkedBookings || []), ...(masterjobStore.bookingListId || [])] 
                        masterjobStore.linkedBookingData = [...(masterjobStore.linkedBookingData || []), ...(masterjobStore.bookingData.filter(
                            booking => masterjobStore.current.linkedBookings.includes(booking._id)
                        ))]           
                        const newData = masterjobStore?.linkedBookingData?.map((e) => ({
                            bookingId: e?._id,
                            hblNumber: e?.erpBookingId || "",
                            erpMasterLinked: false,
                        }));
                        const existingDetails = masterjobStore.current.linkedERPBookingDetails || [];
                        masterjobStore.current.linkedERPBookingDetails = [
                            ...existingDetails,
                            ...newData.filter(
                                (newItem) => !existingDetails.some(
                                    (existing) => existing.bookingId === newItem.bookingId
                                )
                            )
                        ]
                        masterjobStore.current.linkId = masterjobStore?.linkedBookingData?.map((e) => e?._id )
                        masterjobStore.linkedBookings = false;
                    }}
                    style={{
                        background: "#2D3E91",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "8px 24px",
                        cursor: "pointer",
                    }}
                >
                    Link
                </button> : <></>}
            </div>
            <div
                style={{
                    borderRadius: "4px",
                    padding: "10px",
                    background: "#fff",
                }}
            >
                <div
                    style={{
                        maxHeight: "450px",
                        overflowY: "auto",
                    }}
                >
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "separate",
                            borderSpacing: "0 10px",
                        }}
                    >
                        <thead
                            style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 10,
                                background: "#F5F6F8",
                            }}
                        >
                            <tr>
                                {linkedBookingsColumn.map((col) => (
                                    <th
                                        key={col.key}
                                        style={{
                                            padding: "12px",
                                            textAlign: "left",
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#2D3E91",
                                            background: "#F5F6F8",
                                        }}
                                    >
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {bookingData?.length > 0 ? (
                                bookingData?.map((item, index) => (
                                    <tr
                                        key={index}
                                        style={{
                                            background: "#F9FAFB",
                                        }}
                                    >
                                        <td
                                            style={{
                                                padding: "12px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <input type="checkbox" checked={masterjobStore.bookingListId.includes(item._id)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    masterjobStore.bookingListId = [
                                                        ...masterjobStore.bookingListId,
                                                        item._id
                                                    ];
                                                } else {
                                                    masterjobStore.bookingListId =
                                                        masterjobStore.bookingListId.filter(
                                                            id => id !== item._id
                                                        );
                                                }
                                            }} />
                                        </td>
                                        
                                        <td style={{ padding: "12px" }}>
                                            {item._id}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item.shippingBillNo}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item.erpBookingId}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item?.contract?.entityName}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item?.contract?.origin}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item?.contract?.destination}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item?.country?.toLowerCase() == item?.originCount?.toLowerCase() ? 'EXPORT' : item?.country?.toLowerCase() == item?.destinationCount?.toLowerCase() ? 'IMPORT' : ""}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item.contract?.shipmentType?.includes("FCL") ? item?.contract?.containerList?.reduce(
                                                (sum, container) => sum + container.numContainers, 0
                                            ) : 1}
                                        </td>

                                        <td style={{ padding: "12px" }}>
                                            {item.status}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={linkedBookingsColumn.length}
                                        style={{
                                            textAlign: "center",
                                            padding: "40px",
                                            fontWeight: 500,
                                            color: "#666",
                                        }}
                                    >
                                        No data found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                {masterjobStore?.bookingListId?.length > 0 ? <button
                    onClick={()=>{
                        masterjobStore.current.linkedBookings = [...(masterjobStore.current.linkedBookings || []), ...(masterjobStore.bookingListId || [])]
                        masterjobStore.linkedBookingData = masterjobStore.bookingData.filter(
                          booking => masterjobStore.current.linkedBookings.includes(booking._id)
                        );
                        masterjobStore.linkedBookings = false;
                    }}
                    style={{
                        background: "#2D3E91",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "8px 24px",
                        cursor: "pointer",
                    }}
                >
                    Link
                </button>:<></>}
            </div> */}
        </div>
    );
}